import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AdminOverrideBadgeComponent } from '@features/shopping/admin-override/admin-override-badge/admin-override-badge.component';
import { DeviceItemCarrier, DeviceItemData } from '@models/shopping.model';
import { TranslationPipe } from '@pipes/translation/translation.pipe';

@Component({
  selector: 'ts-device-carrier',
  templateUrl: './carrier.component.html',
  imports: [CommonModule, TranslationPipe, AdminOverrideBadgeComponent]
})
export class CarrierComponent {
  @Input() device_items: DeviceItemData[];
  @Input() selected_carrier_id: string | number;
  @Input() is_bp_device: boolean | undefined;
  @Output() selected_carrier = new EventEmitter<DeviceItemCarrier>();

  getCarrierId(item: DeviceItemData): string | number {
    return item.carrier.id;
  }

  getCarrierName(item: DeviceItemData): string {
    return item.carrier.name;
  }

  getCarrierImage(item: DeviceItemData): string {
    return item.carrier.image_url;
  }

  getCarrierAdmin(item: DeviceItemData): boolean | undefined {
    return item.carrier.admin;
  }

  sortCarrier = (device_items: DeviceItemData | any) => {
    if (!device_items) return [];

    return device_items.sort((a: DeviceItemData, b: DeviceItemData) => {
      return this.getCarrierName(a) > this.getCarrierName(b)
        ? 1
        : this.getCarrierName(b) > this.getCarrierName(a)
        ? -1
        : 0;
    });
  };

  selectCarrier(item: DeviceItemData): void {
    this.selected_carrier.emit({
      id: item.carrier.id,
      name: item.carrier.name,
      image_url: item.carrier.image_url,
      admin: item.carrier.admin
    });
  }
}
